import type { WindowLocation } from '@reach/router';

export default function getSearchVariableFromLocation(
    location: WindowLocation,
    variableName: string,
): string | (string | null)[] | null | undefined {
    return new URLSearchParams(location.search).get(variableName);
}
